const icon = {
  edit: 'Edit',
  save: 'Save',
  joomla: 'JoomlaCms',
  processing: 'Processing',
  success: 'Success',
  warning: 'Warning',
  danger: 'Danger',
  failed: 'Failed'
}

export default icon
